var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuestionbankRecord(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_questionbank_record") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CFA\\u9898\\u5E93",
    transform: "translate(-714, -161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_questionbank_record",
    transform: "translate(714, 161)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FFFFFF",
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(8, 8)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,18 C13.9708333,18 18,13.9708333 18,9 C18,4.02916667 13.9708333,0 9,0 C4.02916667,0 0,4.02916667 0,9 C0,13.9708333 4.02916667,18 9,18 Z M9,16.6666667 C6.2609544,16.6666667 3.72996585,15.2054255 2.36043897,12.8333447 C0.99091209,10.461264 0.99091209,7.53873598 2.36043897,5.16665526 C3.72996585,2.79457453 6.2609544,1.33333333 9,1.33333333 C13.2341677,1.33333333 16.6666272,4.76583235 16.6666272,9 C16.6666272,13.2341677 13.2341677,16.6666667 9,16.6666667 L9,16.6666667 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01833334,12.365 C5.85002869,12.5364198 5.78696668,12.7851334 5.85326128,13.0160365 C5.91955589,13.2469395 6.10495322,13.424318 6.33856013,13.4803449 C6.57216703,13.5363718 6.81785119,13.4623815 6.98166666,13.2866667 L10.1983333,9.92833333 C10.3467189,9.77304217 10.429414,9.56645394 10.4291672,9.35166667 L10.4291672,5.66666667 C10.4291672,5.29847683 10.1306898,5 9.7625,5 C9.39431016,5 9.09583333,5.29847683 9.09583333,5.66666667 L9.09583333,9.15083333 L6.01833334,12.365 L6.01833334,12.365 Z",
    id: "\\u8DEF\\u5F84"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionbankRecord);
export default __webpack_public_path__ + "static/media/icon_questionbank_record.svg";
export { ForwardRef as ReactComponent };